import { render } from "./StockTransferShowView.vue?vue&type=template&id=2eee3091&scoped=true"
import script from "./StockTransferShowView.vue?vue&type=script&lang=js"
export * from "./StockTransferShowView.vue?vue&type=script&lang=js"

import "./StockTransferShowView.vue?vue&type=style&index=0&id=2eee3091&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2eee3091"]])

export default __exports__